/* ----------------- React Imports --------------- */
import { useState } from "react";
import type { LayoutChangeEvent } from "react-native";

/* ----------------- Memorang UI --------------- */
import Box from "@memorang/ui/components/Box";
import TaskCard from "@memorang/ui/components/TaskCard";
import { useDevice } from "@memorang/ui/useDevice";

import { ScrollButtonFlatlist } from "@memorang/ui/components/ChatUI/ScrollButtonFlatlist";
/* ----------------- Local Types --------------- */
import type { SectionItems } from "../../types";
import { TasksSkeleton } from "../Skeletons/TasksSkeleton";

interface Props {
	items: SectionItems;
	loading?: boolean;
}
const TasksSection = ({ items, loading }: Props) => {
	const { isMobile } = useDevice();
	const [containerWidth, setContainerWidth] = useState(0);

	if (loading) {
		return <TasksSkeleton />;
	}
	const filteredItems = items.filter((item) => "status" in item);

	const handleLayout = (e: LayoutChangeEvent) => {
		setContainerWidth(e.nativeEvent.layout.width);
	};

	const paddingHorizontal = isMobile ? 16 : 2;
	const gap = 16;
	const availableWidth = containerWidth - paddingHorizontal * 2;

	const cardWidth =
		containerWidth > 0
			? (() => {
					const totalCards = filteredItems.length;

					let cardsToShow: number;
					if (availableWidth < 360) {
						cardsToShow = 1.2;
					} else if (availableWidth < 480) {
						cardsToShow = 1.4;
					} else if (availableWidth < 720) {
						cardsToShow = 2.8;
					} else if (availableWidth < 840) {
						cardsToShow = 3.4;
					} else {
						cardsToShow = 4.0;
					}

					cardsToShow = Math.min(cardsToShow, totalCards);

					return (availableWidth - gap * (cardsToShow - 1)) / cardsToShow;
				})()
			: undefined;

	return (
		<Box onLayout={handleLayout}>
			{containerWidth > 0 && cardWidth && (
				<ScrollButtonFlatlist
					data={filteredItems}
					renderItem={({ item }) => {
						if ("status" in item) {
							return (
								<TaskCard key={item.title} {...item} cardWidth={cardWidth} />
							);
						}
						return null;
					}}
					horizontal
					showsHorizontalScrollIndicator={false}
					contentContainerStyle={{
						paddingHorizontal,
						gap,
						paddingBottom: 8,
					}}
				/>
			)}
		</Box>
	);
};

export default TasksSection;
